import { render, staticRenderFns } from "./MainPageGOH.vue?vue&type=template&id=19a8d554&scoped=true"
import script from "./MainPageGOH.vue?vue&type=script&lang=js"
export * from "./MainPageGOH.vue?vue&type=script&lang=js"
import style0 from "./MainPageGOH.vue?vue&type=style&index=0&id=19a8d554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a8d554",
  null
  
)

export default component.exports